export default __webpack_public_path__ + "static/media/Marker-Icon-Bg-White.61027683.svg";